module.exports = __webpack_public_path__ + "img/huella-carbono-brouche.8119a781.png";